export default function isDarkModeSupportedPage(page: string) {
  return [
    "/",
    "/screener",
    "/financials",
    "/compare",
    "/coupons",
    "/issuers",
    "/discussions",
    "/fatos-relevantes",
    "/ranking",
    "/comments",
    "/feedback",
    "/blog",
    "/portfolio",
    "/bookmarks",
    "/events-calendar",
    "/fiis",
    "/br",
    "/us",
    "/[country]/[tickerSymbol]/valuation",
    "/black/courses",
    "/black/forum",
    "/forum/[postShortId]",
    "/support",
    "/settings",
  ].some((candidate) => {
    return candidate.length === 1 ? page === candidate : page.startsWith(candidate);
  });
}
